import { useState } from 'react';
import './style.scss';

let idValue = 0;

const SearchField = (props) => {
  const {
    label,
    placeholder,
    disabled,
    submitAction,
    showLabel
  } = props;

  const [ searchValue, setSearchValue ] = useState('');

  const id = idValue++;

  return (
    <form className="search-field-container">
      <label
      id={`search-label-${id}`}
      htmlFor={`search-field-${id}`}
    >{showLabel ? label : <span className="sr-hide">{label}</span>}</label>
      <input
      id={`search-field-${id}`}
      type="text"
      placeholder={placeholder}
      disabled={disabled}
      value={searchValue}
      onChange={(e) => {
        e.preventDefault();
        setSearchValue(e.target.value);
      }}
      />
        <button
        id={`search-button-${id}`}
        aria-label="Search"
        aria-labelledby={`search-button-${id} search-label-${id}`}
        type="submit"
        onClick={(e) => {
          e.preventDefault();
          if (typeof submitAction === 'function') {
            submitAction(searchValue);
          }
        }}
        >
          <div className="search-icon" />
          <span className="sr-hide">{label}</span>
        </button>
      </form>
    );
};

export default SearchField;
